// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  haulId: __t.u64().primaryKey().name("haul_id"),
  portId: __t.u64().name("port_id"),
  direction: __t.string(),
  familyKey: __t.string().name("family_key"),
  qty: __t.u32(),
  rewardSov: __t.i64().name("reward_sov"),
  state: __t.string(),
  hauler: __t.identity(),
  shipId: __t.u64().name("ship_id"),
  stationKey: __t.string().name("station_key"),
  offeredAt: __t.timestamp().name("offered_at"),
  acceptedAt: __t.timestamp().name("accepted_at"),
  deadlineAt: __t.timestamp().name("deadline_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
